import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { getWithCovers } from '../../../services/practice-collection-service';
import { getReaderProfileOnboardingConfig } from '../../../services/configuration-service';

export const usePracticeCollectionDetails = () => {
  const { id } = useParams();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [readingCategories, setReadingCategories] = useState([]);

  const fetchDetails = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Fetch config for categories mapping
      const configData = await getReaderProfileOnboardingConfig();
      if (configData.readingCategories) {
        setReadingCategories(configData.readingCategories);
      }

      const data = await getWithCovers(id);
      setContent(data);
    } catch (err) {
      console.error('Failed to load collection details:', err);
      setError(err.message || 'Failed to load collection details');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      fetchDetails();
    }
  }, [id, fetchDetails]);

  return {
    content,
    loading,
    error,
    readingCategories,
    refresh: fetchDetails,
  };
};
